// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'robot-assembly';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.865 10.386a2.833 2.833 0 0 0-2.834 2.833v3.75h5.667v-3.75a2.833 2.833 0 0 0-2.833-2.833zm-1.417.378V6.48m3.365-.733v5.414M1.74 4.896a2.125 2.125 0 1 0 4.25 0 2.125 2.125 0 0 0-4.25 0zm7.083-1.74a2.125 2.125 0 1 0 4.25 0 2.125 2.125 0 0 0-4.25 0zm.284-1.062L5.262 3.295M5.968 5.2l3.139-.981m-8.076 9.354h5.667m6.607-4.866-1.443-3.635M1.031 16.969H16.97m-7.026 0 2.775-5.59 2.774 5.59z'
  />
);

export const viewBox = '0 0 18 18';
